/* eslint-disable no-unused-vars */
import { request, server } from "./request";
// import { getLoginUser } from "./auth";
import Layout from "@/views/layout/Layout";
export function get({ commit, url, name, params, useOtherServerAddress }) {
  // const { storeCode } = getLoginUser() || {};
  // 服务项目传输公用storeId
  // 活动项目传输公用storeCode
  // let querySting = "?";
  // if (params) {
  //   for (let i in params) {
  //     querySting += `${i}=${params[i]}&`;
  //   }
  // }
  // if (!isAdmin) {
  //   querySting += `storeId=${storeId}&storeCode=${storeCode}`;
  // }
  // const data = params || {};
  // params = Object.assign(data, {
  //   storeCode
  // });

  // 非主系统接口
  // if (useOtherServerAddress) {
  //   if (process.env.NODE_ENV === "production") {
  //     const isTestServer = window.location.host.includes("hexin");
  //     url = isTestServer
  //       ? server.service[useOtherServerAddress + "Test"] + url
  //       : server.service[useOtherServerAddress + "Prod"] + url;
  //   } else {
  //     url = server.service[useOtherServerAddress + "Test"] + url;
  //   }
  // }
  return new Promise((resolve, reject) => {
    request({
      url,
      method: "get",
      params
    })
      .then(res => {
        commit(name, res);
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// isAdmin 调用商户充值
export function post({
  commit,
  url,
  name,
  params,
  isQueryString,
  useOtherServerAddress
}) {
  // 服务项目传输公用storeId
  // 活动项目传输公用storeCode
  // const { storeCode } = getLoginUser() || {};
  let data = params || {};
  if (isQueryString) {
    data = Object.keys(data)
      .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
      .join("&");
    url = url + "?" + data;
    data = {};
  }

  // if (useOtherServerAddress == "reportAddress") {
  //   url = server.service["reportAddress"]
  // }

  // 非主系统接口
  // if (useOtherServerAddress) {
  //   if (process.env.NODE_ENV === "production") {
  //     const isTestServer = window.location.host.includes("hexin");
  //     url = isTestServer
  //       ? server.service[useOtherServerAddress + "Test"] + url
  //       : server.service[useOtherServerAddress + "Prod"] + url;
  //   } else {
  //     url = server.service[useOtherServerAddress + "Test"] + url;
  //   }
  // }
  // if (!isAdmin) {
  //   data = Object.assign(data, {
  //     // storeId,
  //     storeCode
  //   });
  // }
  return new Promise((resolve, reject) => {
    request({
      url,
      method: "post",
      data
    })
      .then(res => {
        commit(name, res);
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

//指定随机数范围
export function random(lower, upper) {
  return Math.floor(Math.random() * (upper - lower)) + lower;
}

export function formatFloat(f, digit) {
  let m = Math.pow(10, digit);
  return Math.round(f * m, 10) / m;
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (("" + time).length === 10) time = parseInt(time) * 1000;
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    if (result.length > 0 && value < 10) {
      value = "0" + value;
    }
    return value || 0;
  });
  return time_str;
}

export function formatTime(time, option) {
  time = +time * 1000;
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return "刚刚";
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + "分钟前";
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + "小时前";
  } else if (diff < 3600 * 24 * 2) {
    return "1天前";
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return (
      d.getMonth() +
      1 +
      "月" +
      d.getDate() +
      "日" +
      d.getHours() +
      "时" +
      d.getMinutes() +
      "分"
    );
  }
}

// 生成首页路由
export function generateIndexRouter(data) {
  let indexRouter = [
    {
      path: "/",
      name: "Home",
      component: Layout,
      meta: { title: "首页", icon: "icon-home" },
      redirect: "/home",
      children: [
        {
          path: "home",
          component: () => import("@/views/home/home"),
          meta: {
            title: "首页",
            roles: ["editor", "admin", "activityEditor", "activityAdmin"]
          }
        }
      ]
    },
    {
      path: "*",
      redirect: "/404",
      hidden: true
    },
    ...generateChildRouters(data)
  ];
  return indexRouter;
}

// 生成嵌套路由（子路由）
function isURL(s) {
  return /^http[s]?:\/\/.*/.test(s);
}

function generateChildRouters(data) {
  const routers = [];
  for (let item of data) {
    // 过滤 /guiderCommission 菜单
    if (item.path && item.path.includes("/guiderCommission")) {
      continue;
    }
    let component = "";
    if (item.component.indexOf("Layout") >= 0) {
      component = Layout;
    } else {
      try {
        if (process.env.NODE_ENV === "development") {
          component = require("@/views/" + item.component).default;
        } else {
          // 分割路由
          component = () =>
            import("@/views/" + item.component).catch(() => {
              console.warn(
                `[路由错误] 找不到组件: @/views/${item.component}, 菜单: ${
                  item.name || item.path
                }`
              );
              return import("@/views/404");
            });
        }
      } catch (e) {
        console.warn(
          `[路由错误] 找不到组件: @/views/${item.component}, 菜单: ${
            item.name || item.path
          }`
        );
        component = () => import("@/views/404");
      }
    }

    // eslint-disable-next-line
    let URL = (item.meta.url || '').replace(/{{([^}}]+)?}}/g, (s1, s2) => eval(s2)) // URL支持{{ window.xxx }}占位符变量
    if (isURL(URL)) {
      item.meta.url = URL;
    }

    let menu = {
      path: item.path,
      name: item.name,
      redirect: item.redirect,
      component,
      hidden: item.hidden,

      //component:()=> import(`@/views/${item.component}.vue`),
      meta: {
        title: item.meta.title,
        icon: item.meta.icon,
        url: item.meta.url,
        permissionList: item.meta.permissionList,
        keepAlive: item.meta.keepAlive,
        tab: item.hidden
      }
    };
    if (item.alwaysShow) {
      menu.alwaysShow = true;
      menu.redirect = menu.path;
    }
    if (item.children && item.children.length > 0) {
      menu.children = [...generateChildRouters(item.children)];
    }
    //--update-begin----author:scott---date:20190320------for:根据后台菜单配置，判断是否路由菜单字段，动态选择是否生成路由（为了支持参数URL菜单）------
    //判断是否生成路由
    if (!(item.route && item.route === "0")) {
      routers.push(menu);
    }
    //--update-end----author:scott---date:20190320------for:根据后台菜单配置，判断是否路由菜单字段，动态选择是否生成路由（为了支持参数URL菜单）------
  }
  routers.forEach(v => {
    if (v.name === "Https:www.kancloud.cnhemiaohemiaofqa1331306") {
      v.path = v.redirect;
    }
  });
  return routers;
}

export const drag = {
  params: {
    left: 0,
    top: 0,
    currentX: 0,
    currentY: 0,
    flag: false
  },
  getCss(o, key) {
    return o.currentStyle
      ? o.currentStyle[key]
      : document.defaultView.getComputedStyle(o, false)[key];
  },
  startDrag(dragContainer, dragbleElement) {
    if (this.getCss(dragbleElement, "left") !== "auto") {
      this.params.left = this.getCss(dragbleElement, "left");
    }
    if (this.getCss(dragbleElement, "top") !== "auto") {
      this.params.top = this.getCss(dragbleElement, "top");
    }
    // o是移动对象
    dragContainer.onmousedown = function(event) {
      this.params.flag = true;
      if (!event) {
        event = window.event;
        // 防止IE文字选中
        dragContainer.onselectstart = function() {
          return false;
        };
      }
      const e = event;
      this.params.currentX = e.clientX;
      this.params.currentY = e.clientY;
    }.bind(this);
    document.onmouseup = function() {
      this.params.flag = false;
      if (this.getCss(dragbleElement, "left") !== "auto") {
        this.params.left = this.getCss(dragbleElement, "left");
      }
      if (this.getCss(dragbleElement, "top") !== "auto") {
        this.params.top = this.getCss(dragbleElement, "top");
      }
    }.bind(this);
    document.onmousemove = function(event) {
      const e = event || window.event;
      if (this.params.flag) {
        let nowX = e.clientX;
        let nowY = e.clientY;
        let disX = nowX - this.params.currentX;
        let disY = nowY - this.params.currentY;
        dragbleElement.style.left = `${parseInt(this.params.left) + disX}px`;
        dragbleElement.style.top = `${parseInt(this.params.top) + disY}px`;
        if (event.preventDefault) {
          event.preventDefault();
        }
        return false;
      }
    }.bind(this);
  }
};

export function setCookie({ key, data, type = "local" }) {
  if (type === "local") {
    localStorage.setItem(key, JSON.stringify(data));
  } else {
    sessionStorage.setItem(key, JSON.stringify(data));
  }
}

export function getCookie({ key, type = "local" }) {
  if (type === "local") {
    return JSON.parse(localStorage.getItem(key));
  } else {
    return JSON.parse(sessionStorage.getItem(key));
  }
}

export function removeCookie({ key, type = "local" }) {
  if (type === "local") {
    localStorage.removeItem(key);
  } else {
    sessionStorage.removeItem(key);
  }
}

export function queryActivityCategory({ parentId, childId }) {
  const activityList = [
    {
      typeName: "满送",
      treeId: "FullDelivery",
      nodes: [
        {
          treeId: "NumDelivery",
          typeName: "满件送商品"
        },
        {
          treeId: "PriceDelivery",
          typeName: "满额送商品"
        }
      ]
    },
    {
      treeId: "SpecialPrice",
      typeName: "特价",
      nodes: [
        {
          treeId: "SpecialPrice",
          typeName: "特价"
        }
      ]
    },
    {
      treeId: "FullReduction",
      typeName: "满减",
      nodes: [
        {
          treeId: "NumReduction",
          typeName: "满件减金额"
        },
        {
          treeId: "PriceReduction",
          typeName: "满额减金额"
        }
      ]
    },
    {
      treeId: "CombinationPrice",
      typeName: "组合价",
      nodes: [
        {
          treeId: "packagePrice",
          typeName: "组合价"
        }
      ]
    },
    {
      treeId: "IncreasePurchase",
      typeName: "加价购",
      nodes: [
        {
          treeId: "NumIncrease",
          typeName: "满件数加价购"
        },
        {
          treeId: "PriceIncrease",

          typeName: "满金额加价购"
        }
      ]
    },
    {
      treeId: "FullDiscount",
      typeName: "满折",
      nodes: [
        {
          treeId: "NumDiscount",
          typeName: "满件数打折"
        },
        {
          treeId: "PriceDiscount",
          typeName: "满金额打折"
        }
      ]
    },
    {
      treeId: "FullDeliveryOverlay",
      typeName: "满赠",
      nodes: [
        {
          treeId: "NumDeliveryOverlay",
          typeName: "件数-叠加"
        },
        {
          treeId: "PriceDeliveryOverlay",
          typeName: "金额-叠加"
        }
      ]
    },
    {
      treeId: "SuperpositionGift",
      typeName: "叠加赠送",
      nodes: [
        {
          treeId: "NumSuperposition",
          typeName: "叠加赠送"
        }
      ]
    }
  ];
  const parent = activityList.find(v => v.treeId === parentId);
  const child = parent.nodes.find(v => v.treeId === childId);
  return {
    parentTypeName: parent.typeName,
    childTypeName: child.typeName
  };
}

//求差集
export function getSubtract(arr1, arr2, typeName) {
  return Object.values(
    arr1.concat(arr2).reduce((acc, cur) => {
      if (
        acc[cur[typeName]] &&
        acc[cur[typeName]][typeName] === cur[typeName]
      ) {
        delete acc[cur[typeName]];
      } else {
        acc[cur[typeName]] = cur;
      }
      return acc;
    }, {})
  );
}
//求差集
export function getSubtract2(arr1, arr2) {
  return Object.values(
    arr1.concat(arr2).reduce((acc, cur) => {
      if (
        acc[cur] &&
        acc[cur] === cur
      ) {
        delete acc[cur];
      } else {
        acc[cur] = cur;
      }
      return acc;
    }, {})
  );
}
export function addNum(a, b) {
  var c, d, e;
  try {
    c = a.toString().split(".")[1].length;
  } catch (f) {
    c = 0;
  }
  try {
    d = b.toString().split(".")[1].length;
  } catch (f) {
    d = 0;
  }
  return (e = Math.pow(10, Math.max(c, d))), (a * e + b * e) / e;
}

export function sub(a, b) {
  var c, d, e;
  try {
    c = a.toString().split(".")[1].length;
  } catch (f) {
    c = 0;
  }
  try {
    d = b.toString().split(".")[1].length;
  } catch (f) {
    d = 0;
  }
  return (e = Math.pow(10, Math.max(c, d))), (a * e - b * e) / e;
}

//求最近多少天
export function getDayAndToday(day) {
  let today = new Date();
  let targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
  today.setTime(targetday_milliseconds); //注意，这行是关键代码
  let tYear = today.getFullYear();
  let tMonth = today.getMonth();
  let tDate = today.getDate();

  tMonth = doHandleMonth(tMonth + 1);
  tDate = doHandleMonth(tDate);
  return [
    tYear + "-" + tMonth + "-" + tDate + " " + "00:00:00",
    getNowFormatDate()
  ];
}
export function doHandleMonth(month) {
  let m = month;
  if (month.toString().length == 1) {
    m = "0" + month;
  }
  return m;
}

//日期比较的方法
export function compare(date1, date2) {
  let dates1 = new Date(date1);
  let dates2 = new Date(date2);
  if (dates1 >= dates2) {
    return true;
  } else {
    return false;
  }
}

//求出当前年月日时分秒
export function getNowFormatDate() {
  let date = new Date();
  let seperator1 = "-";

  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  // let hour = date.getHours();
  // let minutes = date.getMinutes();
  // let seconds = date.getSeconds();
  let strDate = date.getDate();

  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  let currentdate =
    year +
    seperator1 +
    month +
    seperator1 +
    strDate +
    " " +
    "23" +
    ":" +
    "59" +
    ":" +
    "59";
  return currentdate;
}

// 时间戳转换为日期格式 yyyy-MM-dd HH:mm:ss
export function timestampToDate(timestamp) {
  const date = new Date(timestamp); // 如果timestamp是数字，直接用于创建Date对象
  const year = date.getFullYear(); // 获取年份
  const month = ('0' + (date.getMonth() + 1)).slice(-2); // 获取月份，转为两位数
  const day = ('0' + date.getDate()).slice(-2); // 获取日，转为两位数
  const hours = ('0' + date.getHours()).slice(-2); // 获取小时，转为两位数
  const minutes = ('0' + date.getMinutes()).slice(-2); // 获取分钟，转为两位数
  const seconds = ('0' + date.getSeconds()).slice(-2); // 获取秒，转为两位数
 
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`; // 拼接字符串返回
}
 

export function isRepeat(arr) {
  var hash = {};
  for (var i in arr) {
    if (hash[arr[i]]) {
      return true;
    }
    hash[arr[i]] = true;
  }
  return false;
}
//数字转化为中文大写
export function numberChinese(str) {
  var num = parseInt(str);
  var strOutput = "",
    strUnit = "仟佰拾亿仟佰拾万仟佰拾元角分";
  num += "00";
  var intPos = num.indexOf(".");
  if (intPos >= 0) {
    num = num.substring(0, intPos) + num.substr(intPos + 1, 2);
  }
  strUnit = strUnit.substr(strUnit.length - num.length);
  for (var i = 0; i < num.length; i++) {
    strOutput +=
      "零壹贰叁肆伍陆柒捌玖".substr(num.substr(i, 1), 1) + strUnit.substr(i, 1);
  }
  return strOutput
    .replace(/零角零分$/, "整")
    .replace(/零[仟佰拾]/g, "零")
    .replace(/零{2,}/g, "零")
    .replace(/零([亿|万])/g, "$1")
    .replace(/零+元/, "元")
    .replace(/亿零{0,3}万/, "亿")
    .replace(/^元/, "零元");
}
//将数字转换成金额显示
export function toMoney(num) {
  if (num) {
    if (isNaN(num)) {
      alert("金额中含有不能识别的字符");
      return;
    }
    num = typeof num == "string" ? parseFloat(num) : num; // 判断是否是字符串如果是字符串转成数字
    num = num.toFixed(2); // 保留两位

    num = parseFloat(num); // 转成数字
    num = num.toLocaleString(); // 转成金额显示模式
    // 判断是否有小数
    if (num.indexOf(".") === -1) {
      num = "￥" + num + ".00";
    } else {
      num = num.split(".")[1].length < 2 ? "￥" + num + "0" : "￥" + num;
    }

    return num; // 返回的是字符串23,245.12保留2位小数
  } else {
    return (num = null);
  }
}
//求交集
export function getInterseciton(arrs) {
  let arr = arrs.shift();
  for (let i = arrs.length; i--; ) {
    const p = { boolean: {}, number: {}, string: {} },
      obj = [];
    arr = arr.concat(arrs[i]).filter(x => {
      const t = typeof x;
      return !(t in p
        ? !p[t][x] && (p[t][x] = 1)
        : obj.indexOf(x) < 0 && obj.push(x));
    });
    if (!arr.length) return [];
  }
  return arr;
}

//去重
export function arrayUnique2(arr, name) {
  let hash = {};
  return arr.reduce(function(item, next) {
    hash[next[name]] ? "" : (hash[next[name]] = true && item.push(next));
    return item;
  }, []);
}

export function unique(arr) {
  return Array.from(new Set(arr));
}
export function group(array, subGroupLength) {
  let index = 0;
  let newArray = [];
  while (index < array.length) {
    newArray.push(array.slice(index, (index += subGroupLength)));
  }
  return newArray;
}
// 获取两个日期差的天/时/分/秒
export function getDateDiff(endDate) {
  const diff = new Date(endDate).getTime() - new Date().getTime();
  // 计算相差天数
  const days = Math.floor(diff / (1000 * 24 * 3600));
  // 计算天数后剩余的毫秒数
  const leavel = diff % (1000 * 24 * 3600);
  const hours = Math.floor(leavel / (1000 * 3600));
  // 计算小时后数后剩余的毫秒数
  const leavel2 = leavel % (1000 * 3600);
  const minutes = Math.floor(leavel2 / (1000 * 60));
  // 计算分钟后剩余的毫秒数
  const leavel3 = leavel2 % (1000 * 60);
  const seconds = Math.round(leavel3 / 1000);

  function format(val) {
    return val < 10 ? "0" + val : val;
  }
  if (days < 0) {
    return "已过期";
  }
  return `${format(days)}天${format(hours)}:${format(minutes)}:${format(
    seconds
  )}`;
}

//比较日期大小
export function compareDate(date1, date2) {
  date1 = new Date(date1);
  date2 = new Date(date2);
  if (date1.getTime() > date2.getTime()) {
    return true;
  } else {
    return false;
  }
}

//手机号脱敏
export function phoneEmailShow(str) {
  let pat = /(\d{3})\d*(\d{4})/;
  return str.replace(pat, "$1****$2");
}

// // 金额转换
// export function changeMoney(num) {
//   var regexp = /(?:\.0*|(\.\d+?)0+)$/;
//   if (num > 1000000) {
//     num = JSON.stringify(num).slice(0, JSON.stringify(num).length - 4) / 100;
//     return num + "万";
//   } else {
//     num = (num / 100).toFixed(2);
//     num = num.replace(regexp, "$1");
//     return num;
//   }
// }

//转千位分隔符
export function toPrice(num) {
  return (
    num &&
    num.toString().replace(/\d+/, function(s) {
      return s.replace(/(\d)(?=(\d{3})+$)/g, "$1,");
    })
  );
}

//base64格式转换为img文件
export function dataURLtoFile(dataurl, filename = "file") {
  let arr = dataurl.split(",");
  let mime = arr[0].match(/:(.*?);/)[1];
  let suffix = mime.split("/")[1];
  let bstr = atob(arr[1]);
  let n = bstr.length;
  let u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], `${filename}.${suffix}`, {
    type: mime
  });
}

//将树形结构数据转为平级数组
export function treeConvertToArr(tree) {
  let arrs = [];
  let result = [];
  arrs = JSON.parse(JSON.stringify(tree));
  while (arrs.length) {
    let first = arrs.shift(); // 弹出第一个元素
    if (first.children) {
      //如果有children
      arrs = arrs.concat(first.children);
      delete first["children"];
    }
    result.push(first);
  }
  return result;
}

export function ChineseToNumber(chnStr) {
  const chnNumChar = {
    零: 0,
    一: 1,
    二: 2,
    三: 3,
    四: 4,
    五: 5,
    六: 6,
    七: 7,
    八: 8,
    九: 9
  };

  const chnNameValue = {
    十: { value: 10, secUnit: false },
    百: { value: 100, secUnit: false },
    千: { value: 1000, secUnit: false },
    万: { value: 10000, secUnit: true },
    亿: { value: 100000000, secUnit: true }
  };
  let rtn = 0;
  let section = 0;
  let number = 0;
  let secUnit = false;
  let str = chnStr.split("");

  for (let i = 0; i < str.length; i++) {
    let num = chnNumChar[str[i]];
    if (typeof num !== "undefined") {
      number = num;
      if (i === str.length - 1) {
        section += number;
      }
    } else {
      let unit = chnNameValue[str[i]].value;
      secUnit = chnNameValue[str[i]].secUnit;
      if (secUnit) {
        section = (section + number) * unit;
        rtn += section;
        section = 0;
      } else {
        section += number * unit;
      }
      number = 0;
    }
  }
  return rtn + section;
}

export function toLunar(solarYear, solarMonth, solarDay) {
  //定义全局变量
  let CalendarData = new Array(100);
  let madd = new Array(12);
  let tgString = "甲乙丙丁戊己庚辛壬癸";
  let dzString = "子丑寅卯辰巳午未申酉戌亥";
  let numString = "一二三四五六七八九十";
  let monString = "正二三四五六七八九十冬腊";
  let weekString = "日一二三四五六";
  let sx = "鼠牛虎兔龙蛇马羊猴鸡狗猪";
  let cYear, cMonth, cDay, TheDate;
  CalendarData = new Array(
    0xa4b,
    0x5164b,
    0x6a5,
    0x6d4,
    0x415b5,
    0x2b6,
    0x957,
    0x2092f,
    0x497,
    0x60c96,
    0xd4a,
    0xea5,
    0x50da9,
    0x5ad,
    0x2b6,
    0x3126e,
    0x92e,
    0x7192d,
    0xc95,
    0xd4a,
    0x61b4a,
    0xb55,
    0x56a,
    0x4155b,
    0x25d,
    0x92d,
    0x2192b,
    0xa95,
    0x71695,
    0x6ca,
    0xb55,
    0x50ab5,
    0x4da,
    0xa5b,
    0x30a57,
    0x52b,
    0x8152a,
    0xe95,
    0x6aa,
    0x615aa,
    0xab5,
    0x4b6,
    0x414ae,
    0xa57,
    0x526,
    0x31d26,
    0xd95,
    0x70b55,
    0x56a,
    0x96d,
    0x5095d,
    0x4ad,
    0xa4d,
    0x41a4d,
    0xd25,
    0x81aa5,
    0xb54,
    0xb6a,
    0x612da,
    0x95b,
    0x49b,
    0x41497,
    0xa4b,
    0xa164b,
    0x6a5,
    0x6d4,
    0x615b4,
    0xab6,
    0x957,
    0x5092f,
    0x497,
    0x64b,
    0x30d4a,
    0xea5,
    0x80d65,
    0x5ac,
    0xab6,
    0x5126d,
    0x92e,
    0xc96,
    0x41a95,
    0xd4a,
    0xda5,
    0x20b55,
    0x56a,
    0x7155b,
    0x25d,
    0x92d,
    0x5192b,
    0xa95,
    0xb4a,
    0x416aa,
    0xad5,
    0x90ab5,
    0x4ba,
    0xa5b,
    0x60a57,
    0x52b,
    0xa93,
    0x40e95
  );
  madd[0] = 0;
  madd[1] = 31;
  madd[2] = 59;
  madd[3] = 90;
  madd[4] = 120;
  madd[5] = 151;
  madd[6] = 181;
  madd[7] = 212;
  madd[8] = 243;
  madd[9] = 273;
  madd[10] = 304;
  madd[11] = 334;

  function GetBit(m, n) {
    return (m >> n) & 1;
  }
  //农历转换
  function e2c() {
    TheDate =
      arguments.length != 3
        ? new Date()
        : new Date(arguments[0], arguments[1], arguments[2]);
    var total, m, n, k;
    var isEnd = false;
    var tmp = TheDate.getYear();
    if (tmp < 1900) {
      tmp += 1900;
    }
    total =
      (tmp - 1921) * 365 +
      Math.floor((tmp - 1921) / 4) +
      madd[TheDate.getMonth()] +
      TheDate.getDate() -
      38;
    if (TheDate.getYear() % 4 == 0 && TheDate.getMonth() > 1) {
      total++;
    }
    for (m = 0; ; m++) {
      k = CalendarData[m] < 0xfff ? 11 : 12;
      for (n = k; n >= 0; n--) {
        if (total <= 29 + GetBit(CalendarData[m], n)) {
          isEnd = true;
          break;
        }
        total = total - 29 - GetBit(CalendarData[m], n);
      }
      if (isEnd) break;
    }
    cYear = 1921 + m;
    cMonth = k - n + 1;
    cDay = total;
    if (k == 12) {
      if (cMonth == Math.floor(CalendarData[m] / 0x10000) + 1) {
        cMonth = 1 - cMonth;
      }
      if (cMonth > Math.floor(CalendarData[m] / 0x10000) + 1) {
        cMonth--;
      }
    }
  }
  function GetcDateString() {
    var tmp = "";
    if (cMonth < 1) {
      // tmp += "(闰)";
      tmp += monString.charAt(-cMonth - 1);
    } else {
      tmp += monString.charAt(cMonth - 1);
    }
    tmp += "月";
    tmp += cDay < 11 ? "初" : cDay < 20 ? "十" : cDay < 30 ? "廿" : "三十";
    if (cDay % 10 != 0 || cDay == 10) {
      tmp += numString.charAt((cDay - 1) % 10);
    }
    return tmp;
  }
  solarMonth = parseInt(solarMonth) > 0 ? solarMonth - 1 : 11;
  e2c(solarYear, solarMonth, solarDay);
  return GetcDateString();
}

/*保留小数（四舍五入）data:要保留的数，val:保留的位数*/
export function ToFixed(data, val) {
  var numbers = "";
  // 保留几位小数后面添加几个0
  for (var i = 0; i < val; i++) {
    numbers += "0";
  }
  var s = 1 + numbers;
  // 如果是整数需要添加后面的0
  var spot = "." + numbers;
  // Math.round四舍五入
  //  parseFloat() 函数可解析一个字符串，并返回一个浮点数。
  var value = Math.round(parseFloat(data) * s) / s;
  // 从小数点后面进行分割
  var d = value.toString().split(".");
  if (d.length == 1) {
    value = value.toString() + spot;
    return value;
  }
  if (d.length > 1) {
    if (d[1].length < 2) {
      value = value.toString() + "0";
    }
    return value;
  }
}

export function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
}
/**
 * 将中文符号转换成英文符号
 */

export function CnChar2EnChar(chineseChar) {
  // 将单引号‘’都转换成'，将双引号“”都转换成"
  var str = chineseChar.replace(/\’|\‘/g, "'").replace(/\“|\”/g, '"');
  // 将中括号【】转换成[]，将大括号｛｝转换成{}
  str = str
    .replace(/\【/g, "[")
    .replace(/\】/g, "]")
    .replace(/\｛/g, "{")
    .replace(/\｝/g, "}")
    .replace(/\（/g, "(")
    .replace(/\）/g, ")");
  // 将逗号，转换成,，将：转换成:
  str = str.replace(/，/g, ",").replace(/：/g, ":");
  return str;
}

export function formatNo(num) {
  let number = num && !isNaN(num) ? +num : 0;
  // 不显示小数点
  // 数字为整数
  if (Number.isInteger(number)) {
    if (number <= 99999) {
      number = (+number).toLocaleString();
    } else if (number > 99999 && number < 999999999) {
      number = (number / 10000).toFixed(2);
      if (number % 1 <= 0) {
        number = +number;
      }
      if (number > 10000) {
        number = Math.trunc(number);
      }
      number = (+number).toLocaleString() + "万";
    } else {
      number = (number / 100000000).toFixed(2);
      if (number % 1 <= 0) {
        number = +number;
      }
      if (number > 10000) {
        number = Math.trunc(number);
      }
      number = (+number).toLocaleString() + "亿";
    }
  } else {
    number = +number.toFixed(2);
    if (number <= 99999.99) {
      if (number > 10000) {
        number = Math.trunc(number);
      }
      number = (+number).toLocaleString();
      if (number.split(".")[1] && number.split(".")[1].length < 2) {
        number += "0";
      }
    } else if (number > 99999.99 && number < 999999999.99) {
      number = (number / 10000).toFixed(2);
      if (number % 1 <= 0) {
        number = +number;
      }
      if (number > 10000) {
        number = Math.trunc(number);
      }
      number = (+number).toLocaleString() + "万";
    } else {
      number = (number / 100000000).toFixed(2);
      if (number % 1 <= 0) {
        number = +number;
      }
      if (number > 10000) {
        number = Math.trunc(number);
      }
      number = (+number).toLocaleString() + "亿";
    }
  }
  return number;
}

export function truncateToTwoDecimalPlaces(num) {  
  const str = num.toString();  
  const dotIndex = str.indexOf('.');  

  // 如果没有小数点，或者小数点后不足两位，直接返回原数字  
  if (dotIndex === -1 || dotIndex >= str.length - 2) {  
      return num;  
  }  

  // 如果小数点后超过两位，则截取到小数点后两位  
  return parseFloat(str.slice(0, dotIndex + 3));  
}  

export function compressImage(file, maxSize = 3 * 1024 * 1024, maxWidth = 3840, maxHeight = 2160) {
  return new Promise((resolve, reject) => {
    // 如果不是图片文件，直接返回原文件
    if (!file.type.startsWith('image/')) {
      resolve(file);
      return;
    }

    // 如果文件已经小于最大大小，直接返回
    if (file.size <= maxSize) {
      resolve(file);
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        // 创建canvas元素用于压缩
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        
        let width = img.width;
        let height = img.height;
        
        // 按比例缩放
        if (width > height) {
          if (width > maxWidth) {
            height = (height * maxWidth) / width;
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width = (width * maxHeight) / height;
            height = maxHeight;
          }
        }
        
        // 设置canvas尺寸
        canvas.width = width;
        canvas.height = height;
        
        // 在canvas上绘制图片
        ctx.drawImage(img, 0, 0, width, height);
        
        // 初始压缩质量
        let quality = 0.9;
        const checkQuality = (currentQuality) => {
          // 转换为Blob对象
          canvas.toBlob(
            (blob) => {
              // 如果压缩后的文件大小满足要求，或者质量已经降到最低，就返回
              if (blob.size <= maxSize || currentQuality <= 0.1) {
                const compressedFile = new File([blob], file.name, {
                  type: 'image/jpeg',
                });
                resolve(compressedFile);
              } else {
                // 否则继续降低质量进行压缩
                checkQuality(Math.max(0.1, currentQuality - 0.1));
              }
            },
            'image/jpeg',
            currentQuality
          );
        };
        
        // 开始检查压缩质量
        checkQuality(quality);
      };
      img.onerror = reject;
      img.src = e.target.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
  /**
 * 图片压缩工具函数
 * @param {File} file - 要压缩的图片文件
 * @param {number} maxSize - 最大文件大小（字节），默认3MB
 * @param {number} maxWidth - 最大宽度，默认1920
 * @param {number} maxHeight - 最大高度，默认1080
 * @returns {Promise<File>} 压缩后的文件
 */
export async function customImageUpload(options) {
  const { 
    action, 
    file, 
    onSuccess, 
    onError, 
    onProgress, 
    fileDir, 
    token,
    data = {},
    validateOptions = {},
    onCompress
  } = options;
  
  // 默认验证配置
  const defaultValidateOptions = {
    allowedExtensions: ['jpg', 'jpeg', 'png', 'bmp', 'gif'],
    maxSize: 3 * 1024 * 1024, // 3MB
    errorMessage: '上传模板只能是 jpg、jpeg、png、bmp格式!'
  };
  
  const finalValidateOptions = { ...defaultValidateOptions, ...validateOptions };
  
  // 文件类型检查
  const fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1).toLowerCase();
  const isValidExtension = finalValidateOptions.allowedExtensions.includes(fileExtension);
  
  if (!isValidExtension) {
    const error = new Error(finalValidateOptions.errorMessage);
    if (onError) {
      onError(error);
    }
    return Promise.reject(error);
  }
  
  // 如果是大图片，先压缩
  let uploadFile = file;
  if (file.type.startsWith('image/') && file.size > finalValidateOptions.maxSize) {
    try {
      if (onCompress) {
        onCompress();
      }
      const compressedFile = await compressImage(file);
      uploadFile = compressedFile;
    } catch (error) {
      console.error('图片压缩失败:', error);
      if (onError) {
        onError(error);
      }
      return Promise.reject(error);
    }
  }
  
  // 执行实际上传
  const formData = new FormData();
  formData.append('file', uploadFile);
  
  // 添加 fileDir 参数
  if (fileDir) {
    formData.append('fileDir', fileDir);
  }
  
  // 添加额外的上传参数
  if (data && typeof data === 'object') {
    Object.keys(data).forEach(key => {
      formData.append(key, data[key]);
    });
  }
  
  return new Promise((resolve, reject) => {
    try {
      const xhr = new XMLHttpRequest();
      
      // 监听上传进度
      xhr.upload.addEventListener('progress', (event) => {
        if (event.lengthComputable && onProgress) {
          onProgress({ percent: (event.loaded / event.total) * 100 });
        }
      });
      
      // 监听上传完成
      xhr.addEventListener('load', () => {
        if (xhr.status === 200) {
          const result = JSON.parse(xhr.responseText);
          if (onSuccess) {
            onSuccess(result);
          }
          resolve(result);
        } else {
          const error = new Error('上传失败');
          if (onError) {
            onError(error);
          }
          reject(error);
        }
      });
      
      // 监听网络错误
      xhr.addEventListener('error', () => {
        const error = new Error('网络错误');
        if (onError) {
          onError(error);
        }
        reject(error);
      });
      
      xhr.open('POST', action);
      xhr.setRequestHeader('X-Access-Token', token);
      xhr.send(formData);
    } catch (error) {
      if (onError) {
        onError(error);
      }
      reject(error);
    }
  });
}